/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from "react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { GetTrackResponse, ShareAnalytics, Track } from "../../proto/api_pb";
import { GetTrackVersionsResponse } from "../../proto/api_pb";
import { RpcError } from "grpc-web";
import { useParams } from "react-router-dom";
import { TrackObj, TrackVersionsObj } from "../MyTracks/types";
import { fetchTrack } from "../../services/trackService";
import { fetchTrackVersions } from "../../services/trackService";
import TrackComponent from "../../components/TrackComponents/TrackComponent";
import { SingleTrackContainer } from "../../components/TrackVersion/styles";
import Mixpanel from "../../utils/mixpanel";
import { toast } from "react-toastify";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { getPaymentMethod } from "../../components/TrackComponents/TrackHandler/trackHandlers";
import {
  AuthContext,
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import {
  AddShareAnalyticsEvent,
  increaseShareUrlViews,
} from "../../services/shareService";
import { enterpriseName, isEnterprise } from "../../theme";
import { Box, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import { Inbox, Session } from "talkjs/all";

export const convertToTrackObj = (
  trackResponse: GetTrackResponse
): TrackObj => {
  const t: Track | undefined = trackResponse.getTrack();
  const tUrl = trackResponse.getTrackVersion()?.getTrackUrl();
  return {
    track: t,
    trackUrl: tUrl!,
    isPlaying: false,
    waveSurfer: undefined,
    versionCount: undefined,
    latestVersion: undefined,
    notifications: undefined,
  };
};
export const SingleTrack: React.FC<{
  userVerified: boolean;
  singleTrackPage: boolean;
  shareObjectId?: string;
  shareToken?: string;
  allowDownload?: boolean;
  setSharePageTitle?: Dispatch<SetStateAction<string | undefined>>;
  session?: Session;
  setInbox?: Dispatch<SetStateAction<Inbox | undefined>>;
  shareId: string;
}> = ({
  userVerified,
  singleTrackPage,
  shareObjectId,
  shareToken,
  allowDownload,
  setSharePageTitle,
  session,
  setInbox,
  shareId,
}) => {
  const [evokeCallBack, setEvokeCallBack] = useState(0);
  const [trackVersions, setTrackVersions] = useState<TrackVersionsObj[]>([]);
  const [track, setTrack] = useState<TrackObj>();
  const [open, setOpen] = useState<boolean>(false);
  const [state, setState] = useState<string>("Uploading track...");
  const [openAddVersionModal, setOpenAddVersionModal] = useState(false);
  const [openAddTrackFileModal, setOpenAddTrackFileModal] = useState(false);
  const [previewState, setPreviewState] =
    useState<string>("Uploading track...");
  const { getValidAccessToken } = useGetValidAccessToken();
  const { id } = useParams();
  const trackId = shareObjectId ? shareObjectId : id;
  const [openCollabsModal, setOpenCollabsModal] = useState(false);
  const [playingTime, setPlayingTime] = useState<any>(0);
  const [audioDuration, setAudioDuration] = useState(0);
  const [intervalTimeout, setIntervalTimeOut] = useState<any>();
  const [isFileAdded, setIsFileAdded] = useState(false);
  const [hasPaymentMethod, setHasPaymentMethod] = useState<boolean>(false);
  const { userId } = useContext(AuthContext);
  const [viewIncreased, setViewIncreased] = useState(false);
  const isSharedContentPage = window.location.pathname.includes("/share/");
  const [isLoading, setIsLoading] = useState(false);
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const { userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  useEffect(() => {
    document.title = isEnterprise
      ? `${enterpriseName} - Track`
      : "OmMuse - Track";
  }, []);
  const stopAllVersionSongs = () => {
    setTrackVersions(trackVersions.map((n) => ({ ...n, isPlaying: false })));
  };
  const handleMainPlay = () => {
    if (track) {
      const song = track?.waveSurfer;
      if (song) {
        song.playPause();
      }
      if (song?.isPlaying()) {
        setTrack({ ...track, isPlaying: true });
        stopAllVersionSongs();
        const timeOut: any = setInterval(() => {
          if (track.waveSurfer) {
            const seekPosition = track.waveSurfer.getCurrentTime();
            setPlayingTime(seekPosition);
          }
          setIntervalTimeOut(timeOut);
        }, 1000);
      } else {
        setTrack({ ...track, isPlaying: false });
        clearInterval(intervalTimeout);
      }
    }
  };

  const handleMainStop = () => {
    if (track) {
      const song = track?.waveSurfer;
      if (song) {
        song.stop();
      }
      if (!song?.isPlaying()) {
        setTrack({ ...track, isPlaying: false });
      }
    }
  };

  const setMainAudioTrack = (_id: string, waveSurfer: WaveSurfer) => {
    if (track) {
      setTrack({ ...track, waveSurfer });
      const audio = new Audio(track.trackUrl);
      audio &&
        audio.addEventListener("loadedmetadata", () => {
          const duration = audio.duration;
          setAudioDuration(duration);
        });
    }
  };
  const handleFetch = useCallback(async () => {
    setIsLoading(true);
    const token = isSharedContentPage
      ? shareToken ?? ""
      : await getValidAccessToken();
    try {
      const response = (await fetchTrack(token, trackId!)) as GetTrackResponse;
      const trackObj = convertToTrackObj(response);
      setTrack(trackObj);
      if (setSharePageTitle) setSharePageTitle(response.getTrack()?.getTitle());
    } catch (e) {
      const error = e as RpcError;
      console.log(error.code);
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [
    getValidAccessToken,
    isSharedContentPage,
    setSharePageTitle,
    shareToken,
    trackId,
  ]);

  const handleAddShareEvent = useCallback(async () => {
    const sh = new ShareAnalytics();
    sh.setShareId(shareId);
    sh.setType("VIEW");
    const response = await fetch("https://ipapi.co/json/");
    if (response.ok) {
      const data = await response.json();
      sh.setIp(data.ip);
      sh.setCountry(data.country_name);
    }
    sh.setTimestamp(Date.now());
    sh.setOmmuseUsername(userName);
    const res = await AddShareAnalyticsEvent(shareToken ?? "", sh);
    if (res instanceof RpcError) toast.warn("Failed to update analytics event");
  }, [shareId, shareToken, userName]);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  useEffect(() => {
    const handleFetchTrackVersions = async () => {
      const token = isSharedContentPage
        ? shareToken ?? ""
        : await getValidAccessToken();
      try {
        const response = (await fetchTrackVersions(
          token,
          trackId!
        )) as GetTrackVersionsResponse;
        const newTrackVersionList = response
          .getTrackVersionsList()
          .map((el) => {
            return { track: el, isPlaying: false };
          });
        setTrackVersions(newTrackVersionList);
      } catch (e) {
        const error = e as RpcError;
        console.log(error.code);
        console.log(error.message);
      }
    };
    handleFetchTrackVersions();
  }, [getValidAccessToken, isSharedContentPage, shareToken, trackId]);

  const handleOpen = () => {
    setEvokeCallBack((prev) => prev + 1);
    setOpen(true);
  };

  const handleCloseModal = (
    setModalState: Dispatch<SetStateAction<boolean>>,
    status?: boolean,
    message?: string
  ) => {
    setModalState(false);
    if (message) toast.success(message);
    if (status) handleFetch();
  };

  const handleCloseCollabsModal = () => {
    setOpenCollabsModal(false);
  };
  const handleOpenCollabsModal = () => {
    setEvokeCallBack((prev) => prev + 1);
    if (track?.waveSurfer?.isPlaying()) {
      track?.waveSurfer?.stop();
    }
    setOpenCollabsModal(true);
  };

  const handleState = (state: string) => {
    setState(`${state}`);
  };

  const handlePreviewState = (state: string) => {
    setPreviewState(`${state}`);
  };

  const openDeleteConfirmModal = (id: string) => {
    Mixpanel.track("delete_track_open");
  };

  const handleOpenVersionModal = () => {
    setEvokeCallBack((prev) => prev + 1);
    setOpenAddVersionModal(true);
  };
  const handleOpenTrackFileModal = () => {
    setEvokeCallBack((prev) => prev + 1);
    setOpenAddTrackFileModal(true);
  };

  const handleUseEffect = useCallback(async () => {
    if (!isSharedContentPage) {
      const token = isSharedContentPage
        ? shareToken ?? ""
        : await getValidAccessToken();

      const getMethod = await getPaymentMethod(token, userId);
      if (getMethod) setHasPaymentMethod(getMethod.getHasPaymentMethod());
    }
  }, [getValidAccessToken, isSharedContentPage, shareToken, userId]);

  useEffect(() => {
    handleUseEffect();
  }, [handleUseEffect]);

  useEffect(() => {
    let shareViewTimeOut: any;
    if (track && !viewIncreased) {
      const song = track.waveSurfer;
      if (song && song.isPlaying() === true) {
        shareViewTimeOut = setTimeout(() => {
          if (isSharedContentPage) {
            increaseShareUrlViews(id!, shareToken!);
            handleAddShareEvent();
          }
          setViewIncreased(true);
        }, 3000);
      }
    }
    return () => {
      clearTimeout(shareViewTimeOut);
    };
  }, [
    id,
    isSharedContentPage,
    track,
    shareToken,
    viewIncreased,
    handleAddShareEvent,
  ]);

  return (
    <>
      <SingleTrackContainer>
        {isLoading && (
          <Box style={styles.libraryContainer}>
            <Box sx={styles.linearProgressContainer}>
              <LinearProgress color="inherit" />
            </Box>
          </Box>
        )}
        {!isLoading && track && (
          <TrackComponent
            item={track}
            setAudioTrack={setMainAudioTrack}
            handlePlay={handleMainPlay}
            handleStop={handleMainStop}
            handleOpen={handleOpen}
            displayForTrackDetails={true}
            versionId={track.track?.getTrackVersionId()}
            handleState={handleState}
            state={state}
            handlePreviewState={handlePreviewState}
            previewState={previewState}
            expand={true}
            handleOpenVersionModal={handleOpenVersionModal}
            handleOpenTrackFileModal={handleOpenTrackFileModal}
            handleFetch={handleFetch}
            userVerified={userVerified}
            handleOpenCollabsModal={handleOpenCollabsModal}
            playingTime={playingTime}
            setPlayingTime={setPlayingTime}
            audioDuration={audioDuration}
            openDeleteConfirmModal={openDeleteConfirmModal}
            singleTrackPage={singleTrackPage}
            isFileAdded={isFileAdded}
            isTrackConnectedToTutorial={false}
            evokeCallBack={evokeCallBack}
            setEvokeCallBack={setEvokeCallBack}
            hasPaymentMethod={hasPaymentMethod}
            allowDownload={allowDownload}
            shareToken={shareToken}
            handleOpenPublishModal={() => setIsPublishModalOpen(true)}
            session={session}
            setInbox={setInbox}
            shareId={shareId}
          />
        )}
      </SingleTrackContainer>
    </>
  );
};
